// extracted by mini-css-extract-plugin
export default {"sortIcon":"MyleTableColumn_sortIcon__anwTZ","columnClickableHeader":"MyleTableColumn_columnClickableHeader__sSs5F"};